import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const polarisOnboardingRoute: InvariantJiraRoute = {
	name: 'polaris-onboarding',
	path: '/welcome/discovery',
	exact: true,
};
